import React from 'react';
import { Text, Button } from '@dotcom/crown-ui';
import styles from './control-button.module.scss';

type ControlButtonProps = {
  addClass?: string;
  label: string;
  onClick: () => void;
  children: React.ReactNode;
  testId?: string;
  buttonClass?: string;
  textClass?: string;
  id?: string;
  ariaLabel?: string;
  ariaControls?: string;
  ref?: React.Ref<HTMLButtonElement>;
  tabIndex?: number;
};

export const ControlButton = ({
  label,
  onClick,
  testId,
  buttonClass,
  textClass,
  children,
  id = undefined,
  ariaLabel = '',
  ariaControls = undefined,
  ref = undefined,
  tabIndex = undefined,
}: ControlButtonProps) => {
  return (
    <Button
      testId={testId}
      onClick={onClick}
      aria-controls={ariaControls}
      aria-label={ariaLabel}
      variant="link"
      id={id}
      tabIndex={tabIndex}
      className={`${styles['control-button']} ${buttonClass}`}
      ref={ref}
    >
      {children}
      {label && (
        <Text className={`${styles['text']} ${textClass}`} styleVariant="helper" color="textPrimary">
          {label}
        </Text>
      )}
    </Button>
  );
};
